__turbopack_context__.v({
  "contactButton": "ContactButton-module-scss-module__fAe4JG__contactButton",
});
